import React from 'react';
import loadingSpinner from '../../assets/gif/loading-spinner.gif';

const LoadingSpinner = ({ width = 150, height = 150 }) => {
  return (
    <div>
      <img src={loadingSpinner} alt="loading spinner" width={`${width}px`} height={`${height}px`} />
    </div>
  );
};

export default LoadingSpinner;
